// extracted by mini-css-extract-plugin
module.exports = {"checkoutLabel":"OrderAttributeCheckbox_checkoutLabel__qVrZs"};